import type { QCStatus } from '@/types';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { cssVar } from '@nautilusbio/nb-design-system/styles/css-variables';
import clsx from 'clsx';
import React, { type FC } from 'react';

import styles from './styles.module.css';

const dotColor: Record<QCStatus, string> = {
  Pass: cssVar.color.success,
  Fail: cssVar.color.danger,
  Partial: cssVar.color.yellow,
  'N/A': cssVar.color.textGray,
};

type QCBadgeProps = {
  className?: string;
  qc: QCStatus | null | undefined;
};

const QCBadge: FC<QCBadgeProps> = ({ className, qc }) => {
  if (!qc) return null;

  return (
    <Stack alignItems="center" as="span" className={className} gap={2} orientation="horizontal">
      <span className={clsx(styles.dot)} style={{ backgroundColor: dotColor[qc] }} />
      {qc}
    </Stack>
  );
};

export default QCBadge;
